/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Deposit(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg
                height='24.000000000000004'
                width='24.000000000000004'
                xmlns='http://www.w3.org/2000/svg'
            >
                <g
                    id='svg_18'
                    stroke='null'
                >
                    <g
                        fill='none'
                        fillRule='evenodd'
                        id='svg_10'
                        transform='matrix(0.6109871731556155,0,0,0.576203064620712,-1.6569598970287593,2.3187577862531548)'
                    >
                        <g
                            id='svg_11'
                            stroke={iconColor || '#FFFFFF'}
                            strokeWidth='2'
                        >
                            <path
                                d='m12.84092,15.603663l-8.1241,0l0,-10.06719c0,-0.55228 0.44772,-1 1,-1l33,0c0.55228,0 1,0.44772 1,1l0,9.06719c0,0.55229 -0.44772,1 -1,1l-7.75,0l0,0'
                                id='svg_16'
                                stroke='null'
                            />
                            <path
                                d='m25.43555,10.971253l-6.43748,0l0,10.07899l-4.14621,0.00004l7.36496,7.09743l7.36496,-7.09743l-4.14676,-0.00004l0.00053,-10.07899z'
                                id='svg_15'
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}